import type {FC} from "react";
import {
    Actions,
    TitleBlock,
    TitleContent,
    TitleVideo,
    TitleInner,
} from "./title.styles";
import {Button} from "@src/components";
import {TitleText, DescriptionText} from "../../price-page.styles";
import {useNavigate} from "react-router-dom";
import {APP_ROUTES} from "@src/core/constants";

export const Title: FC = () => {
    const navigate = useNavigate();
    const goToRegistration = () => {
        navigate(APP_ROUTES.REGISTRATION);
    };
    const user = window.user;

    return (
        <TitleBlock>
            <TitleInner>
                <TitleContent>
                    <TitleText>LightBoxAPI — mock &nbsp;API сервер</TitleText>
                    <DescriptionText>
                        Создавайте mock api в 2 клика, строй api автоматически по документации из swagger и postman.
                    </DescriptionText>
                    {!user.user && (
                    <Actions>
                        <Button
                            variant="contained"
                            text="Пробовать бесплатно"
                            borderradius="L"
                            onClick={goToRegistration}
                        />
                        <Button variant="label" text="Узнать больше" borderradius="L"/>
                    </Actions>)
                }
                </TitleContent>
                <TitleVideo>
                    <iframe
                        width="690"
                        height="372"
                        src="https://www.youtube.com/embed/1eFMhfmhS38"
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                    />
                </TitleVideo>
            </TitleInner>
        </TitleBlock>
    );
};
